import React, { useEffect } from 'react'
import { usePatient } from '~/context'
import { SearchPatientModal } from '~/components/patient/searchPatientModal'
import { useDocumentTitle, useMaternalInfantViewSettings } from '~/hooks'
import { message } from '~/services'
import { db } from '~/data/database'

export const SearchPatient: React.FC = (): JSX.Element => {
  useDocumentTitle(message('titles.search_patient'))
  const { resetPatient, openPatientModal, setOpenPatientModal, errorPatient } = usePatient()
  const { cleanupMaternalInfantViewSettings } = useMaternalInfantViewSettings()

  useEffect(() => {
    setOpenPatientModal(true)
    if (!errorPatient) resetPatient()
    cleanupMaternalInfantViewSettings()
    db.llmChatMessages.clear()
  }, [])

  return <SearchPatientModal show={openPatientModal} onClose={() => setOpenPatientModal(false)} />
}
